import React from 'react';

import { FormattedMessage } from 'react-intl-next';

import messages from './messages';
import { PaginationDetailsStyled } from './styled';

interface Props {
	itemsCount: number;
	totalCount: number;
}

export const PaginationDetails = ({ itemsCount, totalCount }: Props): React.JSX.Element => (
	<PaginationDetailsStyled data-testid="paginated-picker.ui.async-select.pagination-details">
		<FormattedMessage
			{...messages.ofTotalCount}
			values={{
				itemsCount,
				totalCount,
			}}
		/>
	</PaginationDetailsStyled>
);

export default PaginationDetails;
